module.exports = "<div class=\"wrapper\" *ngIf = \"user$ | async as user \">\n  <app-user-portfolio-edit [user]=\"user\"></app-user-portfolio-edit>\n</div>\n"